import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { useAuth } from '../contexts/AuthContext.js';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../config.js';
import { ScrollTop } from 'primereact/scrolltop';
import { ProgressBar } from 'primereact/progressbar';   
import { OverlayPanel } from 'primereact/overlaypanel';
import { Messages } from 'primereact/messages';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import Login from './Login.js';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';

const SupportCustomers = () => {
  // Load the status page script
  useStatusPageScript();
  
  const { id } = useParams();
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const { logout } = useAuth();
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    lms: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState(20);
  const op = useRef(null);
  const msgs = useRef(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const toast = useRef(null);

  const handleLoginSuccess = () => {
      setShowLoginModal(false);
      if (toast.current) {
          toast.current.show({severity: 'success', summary: '', detail: 'Login successful! You can continue working.'});
      }
      getEvents(rows, 0);
  };

  useEffect(() => {
    const fetchEvents = async () => {
        getEvents(rows,0);
    };

    fetchEvents();
    let _filters = JSON.parse(localStorage.getItem('customersFilters'));
    if (_filters) {
      setFilters(_filters);
      setGlobalFilterValue(_filters.global.value);
    }
  }, [id]);

  const getEvents = async () => {
    try {
        setLoading(true);
        setEvents([]);
        const token = localStorage.getItem('token');
        const id = localStorage.getItem('appid');
        const url =  global.config.url + `/support/getcustomers?appProviderId=${id}`;
        const response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setEvents(response.data);
          setLoading(false);
      } catch (error) {
        console.error('Error fetching event record:', error);
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            setShowLoginModal(true);
          }
          setLoading(false);
          setEvents([]);
      }
      

    };

  const onPageChange = (event) => {
    setLoading(true);
    setRows(event.rows);
    getEvents(event.rows, event.page);
  };
  
  const optionsSelected = (e, rowData) =>{
      // op.current.toggle(e);
      setRowSelectionModel(rowData);
    }

  const optionsTemplate = (rowData) => {
    return <Button link icon="pi pi-ellipsis-v" onClick={(e) => optionsSelected(e, rowData)} />;
  };

  const getLocations = async (data) => {
    if(data === undefined || data.id === 0 || data.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a customer to view its locations.'});
    }
    else{
      // navigate(`/accesspoints/client/${rowSelectionModel.name}/${rowSelectionModel.id}`);
      // msgs.current.show({severity: 'info', summary: '', detail: rowSelectionModel.name + ' access clients are not yet implemented.'});
      localStorage.setItem('id', data.id);
      localStorage.setItem('supportcustomer', data.name);
      navigate(`/support/sites/`);
    }
  }
  const startContent = (
      <React.Fragment>
        <div>
          <Button onClick={() => getLocations()} label="Get Clients" icon="pi pi-desktop" className="p-button-primary mb-3 ml-3" tooltip="Get clients for this location" tooltipOptions={{position:"bottom"}}/>
          {/* <Button onClick={() => getAccessPoints()} label="Get Tiles" icon="pi pi-qrcode" className="p-button-warning mb-3 ml-3" tooltip="Get tiles for this location" tooltipOptions={{position:"bottom"}}/> */}
        </div>
      </React.Fragment>
  );

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    localStorage.setItem('customersFilters', JSON.stringify(_filters));

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const clearFilter = () => {
  let _filters = { ...filters };
  _filters['global'].value = null;
  setFilters(_filters);
  setGlobalFilterValue('');
  localStorage.removeItem('customersFilters');
};
  const progressbar = (        
    <div className="card mt-3">
        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
    </div>);

  const logoutUser = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <Card className='justify-content-md-center mt-5'>
      <script src="https://smarttile.statuspage.io/embed/script.js"></script>
      <Container fluid="md" >
      <div className="panel">
        <div className="flex align-content-center flex-wrap">
          <h4 className='flex mt-2 mb-3'>Customers</h4> 
          <span className="p-input-icon-left mb-3 ml-3">
            <i className="pi pi-search" />
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Filter Search" tooltip="Start typing to filter" 
              tooltipOptions={{position: "bottom"}}/>
          </span>
          <Button icon="pi pi-times" className="p-button-text mb-3"  onClick={() => clearFilter()} tooltip="Clear filter" tooltipOptions={{position: "bottom"}} />
          {/* <Button label="Audit Logs" icon="pi pi-history" className="p-button-text mb-3 ml-2" onClick={() => navigate('/support/auditlogs')} tooltip="Open support audit logs" tooltipOptions={{position:"bottom"}} /> */}
        </div>
        {/* <Toolbar           
        start={

        } 
        end = {        
          }/> */}
      </div>
      {loading && progressbar}
      <Messages ref={msgs} />
      <Toast ref={toast} />
        <Row className='justify-content-md-center mt-5'>
            <Col>
            <DataTable value={events} selectionMode={'radiobutton'} selection={rowSelectionModel} onSelectionChange={(e) => setRowSelectionModel(e.value)} 
            onRowSelect={(e) => getLocations(e.data)}
            dataKey="id" tableStyle={{ minWidth: '50rem' }} filters={filters} filterDisplay="menu" emptyMessage={loading ? "Loading locations..." : "No locations found."}
            globalFilterFields={['name', 'code', 'lms']} 
            scrollable scrollHeight="60vh">
                {/* <Column field="options" header="" body={optionsTemplate}> </Column> */}
                <Column field="name" header="Name" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} sortable></Column>
                <Column field="code" header="Code" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }}></Column>
                <Column field="lms" header="LMS" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }}></Column>
            </DataTable>
            </Col>

        </Row>
        <OverlayPanel ref={op}>
          {startContent}
        </OverlayPanel>
        <div className="card flex justify-content-center">
          <Dialog 
            header="Session Expired - Please Login Again" 
            visible={showLoginModal} 
            style={{ width: '450px' }} 
            modal={true}
            closable={false}
            className="justify-content-center"
          >
            <p className="mb-3">Your session has expired. Please log in again to continue working without losing your form data.</p>
            <div className="flex justify-content-center">
              <Login onLoginSuccess={handleLoginSuccess} />
            </div>
          </Dialog>
        </div>
      </Container>
    <ScrollTop />
    </Card>
  );
};

export default SupportCustomers;
